import _implicitStylesheets from "./tabGroup.css";
import _implicitScopedStylesheets from "./tabGroup.scoped.css?scoped=true";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<li active role="presentation"${3}><a${"a1:id"}${"a1:tab-key"}${"a1:href"}${"a1:type-style"} role="tab" aria-selected="true" tabindex="0"${3}>${"t2"}</a></li>`;
const $fragment2 = parseFragment`<li role="presentation"${3}><a${"a1:id"}${"a1:tab-key"}${"a1:href"}${"a1:type-style"} role="tab" aria-selected="false" tabindex="-1"${3}>${"t2"}</a></li>`;
const stc0 = {
  "role": "tablist"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, k: api_key, gid: api_scoped_id, fid: api_scoped_frag_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, i: api_iterator, h: api_element} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("ul", {
    attrs: stc0,
    key: 0,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleTabKeydown))
    }
  }, api_iterator($cmp.tabs, function (tab) {
    return [tab.active ? api_custom_element("wds-link", _wdsLink, {
      props: {
        "name": tab.id,
        "label": tab.label,
        "href": tab.url
      },
      key: api_key(1, tab.label),
      on: {
        "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleAnalytics))
      }
    }, [api_static_fragment($fragment1, 3, [api_static_part(1, {
      attrs: {
        "id": api_scoped_id(tab.id),
        "tab-key": tab.id,
        "href": api_scoped_frag_id(tab.url),
        "type-style": $cmp.responsiveState.tabTypeStyle
      }
    }, null), api_static_part(2, null, api_dynamic_text(tab.label))])]) : null, !tab.active ? api_custom_element("wds-link", _wdsLink, {
      props: {
        "name": tab.id,
        "label": tab.label,
        "href": tab.url
      },
      key: api_key(4, tab.label),
      on: {
        "analytics": _m2 || ($ctx._m2 = api_bind($cmp.handleAnalytics))
      }
    }, [api_static_fragment($fragment2, 6, [api_static_part(1, {
      attrs: {
        "id": api_scoped_id(tab.id),
        "tab-key": tab.id,
        "href": api_scoped_frag_id(tab.url),
        "type-style": $cmp.responsiveState.tabTypeStyle
      }
    }, null), api_static_part(2, null, api_dynamic_text(tab.label))])]) : null];
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3pt6nhafd17";
tmpl.legacyStylesheetToken = "undefined-_tabGroup";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
